import ReactLoading from 'react-loading';
import PropTypes from 'prop-types';

function FullpageLoading({ mask }) {
  return (
    <div style={{
      backgroundColor: mask ? 'rgb(0 0 0 / 15%)' : '',
      position: 'fixed',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 100,
    }}
    >
      <ReactLoading type="bars" color="#645AFF" />
    </div>
  );
}
FullpageLoading.propTypes = {
  mask: PropTypes.bool,
};
FullpageLoading.defaultProps = {
  mask: false,
};

export default FullpageLoading;
